import * as React from 'react';
import DataProvider from '../DataProvider'

 /**
   * Retrieves a contact list from the API.
   * @param {string} contactListId The ID of the contact list to retrieve.
   * @returns {Promise} A promise that resolves to the contact list.
   */
 async function getContactList(contactListId) {
    const data = await DataProvider.getOne('contactlists', { id: contactListId });
    return data.data;
  }
  

  export {
    getContactList
  }